export const CAMPAIGNS_ACCESS = 'campaigns-access';
export const CAMPAIGNS_WRITE = 'campaigns-write';
export const CONTACTS_LISTS_ACCESS = 'contacts-lists-access';
export const ADS_WRITE = 'ads-write';
export const EMAIL_WRITE = 'email-write';
export const WORKFLOWS_ACCESS = 'workflows-access';
export const WORKFLOWS_APP_ACCESS = 'workflows-app-access';
export const WORKFLOWS_DEALS_SPECIFIC_ACTIONS_ACCESS = 'workflows-deals-access';
export const WORKFLOWS_TICKETS_SPECIFIC_ACTIONS_ACCESS = 'workflows-tickets-specific-actions-access';
export const WORKFLOWS_CREATE_INLINE_EMAIL_ACCESS = 'workflows-create-inline-email-access';
export const WORKFLOWS_EXTENSION_ACTION_ACCESS = 'workflows-extension-action-access';
export const MARKETABLE_CONTACTS_ACCESS = 'marketable-contacts-access';
export const WEBHOOK_ACCESS = 'workflows-webhook-access';
export const BEHAVIORAL_EVENTS_READ = 'behavioral-events-read';
export const CUSTOM_CODE_ACCESS = 'workflows-custom-code-access';
export const FORMAT_DATA_ACCESS = 'workflows-format-data-access';
export const ACTION_SETS_ACCESS = 'workflows-action-sets-access';
export const ASSIGN_TEAMS_ACCESS = 'workflows-assign-teams-access';
export const BUSINESS_UNITS_ACCESS = 'business-units-access';

// customer-data-filters
export const CRM_FILTER_VIEWS_ALL = 'crm-views-all';

// Granular Permission scopes
export const WORKFLOWS_EDIT_ALL = 'workflows-edit-all';
export const WORKFLOWS_EDIT_TEAM_OWNED = 'workflows-edit-team-owned';
export const WORKFLOWS_PERMISSION_CREATE_WORKFLOW_TEAM_OWNED = 'workflows-permission-create-workflow-team-owned';
export const INTEGRATIONS_MANAGEMENT = 'integrations-management';
export const INTEGRATIONS_MANAGEMENT_WRITE = 'integrations-management-write';

// Contextual Automation scopes
export const WORKFLOWS_CONTEXTUAL_MARKETING_FREE = 'workflows-contextual-marketing-free';
export const WORKFLOWS_CONTEXTUAL_MARKETING_STARTER = 'workflows-contextual-marketing-starter';
export const WORKFLOWS_CONTEXTUAL_MARKETING_PRO = 'workflows-contextual-marketing-pro';
export const WORKFLOWS_CONTEXTUAL_MARKETING_ENTERPRISE = 'workflows-contextual-marketing-enterprise';
export const WORKFLOWS_CONTEXTUAL_CREATE_INLINE_EMAIL_ACCESS = 'workflows-contextual-create-inline-email-access';
export const EMAIL_TYPE_WORKFLOWS_ACCESS = 'email-type-workflows-access';

// Notification scopes
export const WORKFLOWS_ANOMALY_NOTIFICATIONS = 'workflows-anomaly-notifications';
export const WORKFLOWS_RISK_NOTIFICATIONS = 'workflows-risk-notifications';
export const WORKFLOWS_CONVERSION_REPORTING = 'workflows-conversion-reporting';